var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.258,
    height: 40,
    viewBox: "0 0 32.258 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-14 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M43.032,42H17.226A3.235,3.235,0,0,1,14,38.774V5.226A3.235,3.235,0,0,1,17.226,2H30.355a3.193,3.193,0,0,1,2.29.935L45.323,15.613a3.193,3.193,0,0,1,.935,2.29V38.774A3.235,3.235,0,0,1,43.032,42ZM17.226,3.29A1.941,1.941,0,0,0,15.29,5.226V38.774a1.941,1.941,0,0,0,1.935,1.935H43.032a1.941,1.941,0,0,0,1.935-1.935V17.9a1.806,1.806,0,0,0-.581-1.355L31.71,3.871a1.806,1.806,0,0,0-1.355-.581Z",
    fill: "#1d409d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M53.161,72.765H50.484L49,66.958c-.065-.194-.161-.645-.29-1.29a10.793,10.793,0,0,1-.226-1.29c-.032.258-.1.71-.226,1.323s-.226,1.032-.29,1.29l-1.484,5.774H43.806L41,61.7h2.29l1.419,6.032c.258,1.129.419,2.065.548,2.9.032-.29.1-.742.194-1.323s.226-1.065.29-1.387l1.613-6.194h2.226l1.613,6.194c.065.29.161.71.258,1.258s.194,1.065.258,1.452c.065-.387.129-.871.258-1.484s.226-1.065.29-1.419L53.677,61.7h2.29Z",
    transform: "translate(-18.29 -40.442)",
    fill: "#1d409d"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.bb734cdf5dc82b33190c78eb3ed75018.svg";
export { ForwardRef as ReactComponent };